'use strict'

let propContextMenuState = null
let propHelpPanelState = null
let propMiniToastTimer = null
const KMZ_SCOPE_VARIANTS = ['template', 'waylines', 'both', 'none', 'unresolved']
const KMZ_SCOPE_TABLE_ROWS = ['template', 'waylines', 'both', 'none', 'unresolved']
const KMZ_SCOPE_TABLE_STATE_BY_ROW = {
  template: { template: 'yes', waylines: 'no' },
  waylines: { template: 'no', waylines: 'yes' },
  both: { template: 'yes', waylines: 'yes' },
  none: { template: 'no', waylines: 'no' },
  unresolved: { template: 'unknown', waylines: 'unknown' }
}

const escapePropContextHtml = function (rawText) {
  return String(rawText === null || rawText === undefined ? '' : rawText)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

const textToPropContextHtml = function (rawText) {
  return escapePropContextHtml(rawText).replace(/\r?\n/g, '<br>')
}

const resolveKmzScopeVariant = function (data) {
  const variant = String((data && data.kmzScopeVariant) || '').trim().toLowerCase()
  return KMZ_SCOPE_VARIANTS.includes(variant) ? variant : ''
}

const applyKmzScopePreviewMarkerAttrs = function (node, variant) {
  if (!(node instanceof HTMLElement)) return
  node.removeAttribute('data-kmz-scope-help-color')
  if (KMZ_SCOPE_VARIANTS.includes(variant)) {
    node.setAttribute('data-kmz-scope-help-color', variant)
  }
}

const renderKmzScopePreview = function (container, variant, fnT) {
  if (!(container instanceof HTMLElement) || !variant) return false
  const markerEl = container.querySelector('[data-prop-context-help-preview-marker]')
  const textEl = container.querySelector('[data-prop-context-help-preview-text]')
  if (!(markerEl instanceof HTMLElement) || !(textEl instanceof HTMLElement)) return false
  const markerText = String(container.getAttribute('data-prop-context-preview-marker-' + variant) || '').trim() || fnT('kmz.scope.table.' + variant + '_marker')
  const meaningText = String(container.getAttribute('data-prop-context-preview-meaning-' + variant) || '').trim() || fnT('kmz.scope.table.' + variant + '_meaning')
  markerEl.textContent = markerText
  textEl.textContent = ': ' + meaningText
  applyKmzScopePreviewMarkerAttrs(markerEl, variant)
  return true
}

const buildKmzScopeTable = function (fnT, currentVariant) {
  const table = cloneTemplateRoot('[data-tpl-kmz-scope-help-table]')
  if (!(table instanceof HTMLElement)) return null
  const unresolvedMeaning = String((table.getAttribute('data-kmz-scope-help-unresolved-meaning') || '')).trim() || fnT('kmz.scope.table.unresolved_meaning')
  KMZ_SCOPE_TABLE_ROWS.forEach((rowKey) => {
    const rowEl = table.querySelector('[data-kmz-scope-help-row="' + rowKey + '"]')
    ;['template', 'waylines'].forEach((colKey) => {
      const cellEl = table.querySelector('[data-kmz-scope-help-cell-row="' + rowKey + '"][data-kmz-scope-help-cell-col="' + colKey + '"]')
      if (!(cellEl instanceof HTMLElement)) return
      const rowStateMap = KMZ_SCOPE_TABLE_STATE_BY_ROW[rowKey] || {}
      const state = String(rowStateMap[colKey] || 'unknown')
      cellEl.setAttribute('data-kmz-scope-help-cell-state', state)
      cellEl.setAttribute('aria-label', state === 'yes' ? '1' : (state === 'no' ? '0' : '?'))
      cellEl.setAttribute('title', state === 'yes' ? '1' : (state === 'no' ? '0' : unresolvedMeaning))
    })
    if (rowEl instanceof HTMLElement) {
      rowEl.setAttribute('data-kmz-scope-help-current', rowKey === currentVariant ? '1' : '0')
    }
  })
  return table
}

const cloneTemplateRoot = function (selector) {
  if (typeof document === 'undefined') return null
  const template = document.querySelector(selector)
  if (!(template instanceof HTMLTemplateElement)) return null
  const root = template.content.firstElementChild
  return root ? root.cloneNode(true) : null
}

const getPropUiHost = function () {
  if (typeof window !== 'undefined') {
    const baseSwal = window.PORTAL_BASE_SWAL || window.Swal || null
    if (baseSwal && typeof baseSwal.getPopup === 'function') {
      const popup = baseSwal.getPopup()
      if (popup) {
        const position = window.getComputedStyle(popup).position
        if (position === 'static') popup.style.position = 'relative'
        return popup
      }
    }
  }
  return document.body
}

const hidePropContextMenu = function () {
  if (!propContextMenuState || !propContextMenuState.node) return
  propContextMenuState.node.remove()
  propContextMenuState = null
}

const hidePropHelpPanel = function () {
  if (!propHelpPanelState || !propHelpPanelState.node) return
  propHelpPanelState.node.remove()
  propHelpPanelState = null
}

const copyTextToClipboard = async function (text) {
  const value = String(text || '')
  if (!value) return false
  try {
    if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      await navigator.clipboard.writeText(value)
      return true
    }
  } catch (_error) {}
  try {
    const input = document.createElement('textarea')
    input.value = value
    input.setAttribute('readonly', 'readonly')
    input.style.position = 'fixed'
    input.style.left = '-9999px'
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    return true
  } catch (_error) {
    return false
  }
}

const showPropMiniToast = function (message, isError) {
  const host = getPropUiHost()
  let toastEl = host.querySelector('[data-prop-context-toast]')
  if (!toastEl) {
    toastEl = document.createElement('div')
    toastEl.setAttribute('data-prop-context-toast', '1')
    host.appendChild(toastEl)
  }
  toastEl.textContent = String(message || '')
  toastEl.setAttribute('data-prop-context-toast-error', isError ? '1' : '0')
  if (propMiniToastTimer) clearTimeout(propMiniToastTimer)
  propMiniToastTimer = setTimeout(function () {
    if (toastEl && toastEl.parentNode) {
      toastEl.parentNode.removeChild(toastEl)
    }
  }, 1600)
}

const buildTf = function (fnT) {
  return function (key, vars, fallback) {
    const template = String(fnT(key, fallback || key) || fallback || key || '')
    const data = (vars && typeof vars === 'object') ? vars : {}
    return template.replace(/\{([a-zA-Z0-9_]+)\}/g, function (_match, token) {
      return Object.prototype.hasOwnProperty.call(data, token) ? String(data[token]) : ''
    })
  }
}

const openPropHelpPanel = function (data, fnT) {
  const label = String((data && data.label) || '').trim()
  const fullName = String((data && data.fullName) || '').trim()
  const shortHelp = String((data && data.helpShort) || '').trim()
  const detailedHelp = String((data && data.helpDetailed) || '').trim()
  const variant = resolveKmzScopeVariant(data)
  const html = textToPropContextHtml(detailedHelp || shortHelp || fnT('help.no_extra'))
  hidePropHelpPanel()
  const host = getPropUiHost()
  const panel = cloneTemplateRoot('[data-tpl-prop-help-panel]')
  if (!panel) return
  const titleEl = panel.querySelector('[data-prop-help-panel-title]')
  const fieldEl = panel.querySelector('[data-prop-help-panel-field]')
  const fieldValueEl = panel.querySelector('[data-prop-help-panel-field-value]')
  const contentEl = panel.querySelector('[data-prop-help-panel-content]')
  const scopeEl = panel.querySelector('[data-prop-help-panel-scope]')
  const closeEl = panel.querySelector('[data-prop-help-close]')
  if (titleEl) titleEl.textContent = label || fullName || fnT('common.help')
  if (fieldValueEl) {
    fieldValueEl.textContent = fullName || label || '-'
  } else if (fieldEl) {
    fieldEl.textContent = fnT('common.field') + ': ' + (fullName || label || '-')
  }
  if (contentEl) contentEl.innerHTML = html
  if (scopeEl instanceof HTMLElement) {
    scopeEl.innerHTML = ''
    if (variant) {
      const table = buildKmzScopeTable(fnT, variant)
      if (table) scopeEl.appendChild(table)
    }
  }
  panel.addEventListener('mousedown', function (event) { event.stopPropagation() })
  panel.addEventListener('pointerdown', function (event) { event.stopPropagation() })
  panel.addEventListener('click', function (event) { event.stopPropagation() })
  panel.addEventListener('contextmenu', function (event) { event.stopPropagation() })
  if (closeEl) {
    closeEl.addEventListener('click', function () {
      hidePropHelpPanel()
    })
  }
  host.appendChild(panel)
  propHelpPanelState = { node: panel }
}

const createPortalPropContextMenu = function ({
  fnT = function (key, fallback) { return String(fallback || key || '') }
} = {}) {
  const fnTF = buildTf(fnT)
  const showPropContextMenu = function (event, data) {
    if (!event || !data) return
    event.preventDefault()
    event.stopPropagation()
    hidePropContextMenu()
    const fullName = String((data && data.fullName) || '').trim()
    if (!fullName) return
    const shortHelp = String((data && data.helpShort) || '').trim() || fnT('help.no_short')
    const variant = resolveKmzScopeVariant(data)
    const host = getPropUiHost()
    const hostRect = host.getBoundingClientRect()
    const relX = Math.max(0, (event.clientX || 0) - hostRect.left)
    const relY = Math.max(0, (event.clientY || 0) - hostRect.top)
    const menu = cloneTemplateRoot('[data-tpl-prop-context-menu]')
    if (!menu) return
    const copyBtn = menu.querySelector('[data-prop-context-copy]')
    const helpBtn = menu.querySelector('[data-prop-context-help]')
    const helpPreviewPlainEl = menu.querySelector('[data-prop-context-help-preview-plain]')
    const helpPreviewScopeEl = menu.querySelector('[data-prop-context-help-preview-scope]')
    if (copyBtn) copyBtn.textContent = fnT('common.copy') + ': ' + fullName
    if (helpPreviewPlainEl instanceof HTMLElement) {
      const hasPlainHelp = !!String(shortHelp || '').trim()
      helpPreviewPlainEl.innerHTML = hasPlainHelp ? textToPropContextHtml(shortHelp) : ''
      helpPreviewPlainEl.style.display = hasPlainHelp ? '' : 'none'
    }
    if (helpPreviewScopeEl instanceof HTMLElement) {
      helpPreviewScopeEl.style.display = (variant && renderKmzScopePreview(helpPreviewScopeEl, variant, fnT)) ? '' : 'none'
    }
    host.appendChild(menu)
    menu.style.left = relX + 'px'
    menu.style.top = relY + 'px'
    menu.addEventListener('mousedown', function (e) { e.stopPropagation() })
    menu.addEventListener('pointerdown', function (e) { e.stopPropagation() })
    menu.addEventListener('click', function (e) { e.stopPropagation() })
    menu.addEventListener('contextmenu', function (e) { e.stopPropagation() })
    const rect = menu.getBoundingClientRect()
    const maxLeft = Math.max(8, hostRect.width - rect.width - 8)
    const maxTop = Math.max(8, hostRect.height - rect.height - 8)
    menu.style.left = Math.max(8, Math.min(relX || 8, maxLeft)) + 'px'
    menu.style.top = Math.max(8, Math.min(relY || 8, maxTop)) + 'px'
    propContextMenuState = { node: menu }
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        void copyTextToClipboard(fullName).then(function (ok) {
          if (ok) {
            showPropMiniToast(fnTF('copy.done', { value: fullName }, fullName), false)
          } else {
            showPropMiniToast(fnT('copy.failed'), true)
          }
        })
        hidePropContextMenu()
      })
    }
    if (helpBtn) {
      helpBtn.addEventListener('click', function () {
        openPropHelpPanel(data, fnT)
        hidePropContextMenu()
      })
    }
  }
  document.addEventListener('click', hidePropContextMenu)
  document.addEventListener('scroll', hidePropContextMenu, true)
  document.addEventListener('keydown', function (event) {
    if (String((event && event.key) || '') === 'Escape') {
      hidePropContextMenu()
      hidePropHelpPanel()
    }
  })
  return showPropContextMenu
}

export {
  createPortalPropContextMenu
}
